import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import ListLinkBox from '../../../components/UI/ListLinkBox';
import { translate, msgAppHandler } from '../../../utils/util';
import AreaService from '../../../services/AreaService';
import * as actionsTruckKanban from '../../../actions/truckKanbanAction';

const TruckKanban = (props) => {
    const menu = () => {
        let menuItems = [];

        menuItems = [...menuItems, { route: 'parameters', icon: 'assignment_turned_in', text: translate('physical-confirmation:xd-conference') }];
        menuItems = [...menuItems, { route: 'spacexd', icon: 'clear_all', text: translate('physical-confirmation:xd-space') }];
        menuItems = [...menuItems, { route: 'fastspacexd', icon: 'mdi mdi-truck-fast', text: "MVI Rápido" }];
        menuItems = [...menuItems, { route: 'mviList', icon: 'mdi mdi-clipboard-list-outline', text: translate('mvi-list', 'truck-kanban') }];
        menuItems = [...menuItems, { route: 'transmissionLog', icon: 'mdi mdi-file-alert-outline', text: translate('transmission-log', 'truck-kanban') }];

        menuItems = [...menuItems, {
            route: {
                pathname: 'printlabel',
                state: { truckKanban: true }
            }, icon: 'print',
            text: translate('label-reprint', 'physical-confirmation')
        }];
        menuItems = [...menuItems, { route: 'registrations', icon: 'mdi mdi-clipboard-list-outline', text: translate('registrations', 'truck-kanban') }];
        return menuItems;
    };

    useEffect(() => {
        //Remove Evento Antigo e add novamente
        props.resetTruckKanban();
        document.removeEventListener('message', msgAppHandler);
        document.addEventListener('message', msgAppHandler);
        props.getAreas(props.user.vision, {
            plantId: props.user.vision.split('-')[0]
        }, {});
        // eslint-disable-next-line
    }, []);

    return (
        <div>
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-dolly" />
                        {translate('physical-confirmation:xd-space')}
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox
                    options={menu()}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAreas: (vision, filter, pagination) => {
            dispatch(AreaService.getAreas(vision, filter, pagination));
        },
        resetTruckKanban: () => {
            dispatch(actionsTruckKanban.clearTruckKanban());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TruckKanban));